import t from "@/lang/lang";
import { GSMDocumentKind } from "@/services/backend/documents/types/kind";
import { ConfirmationDataCard } from "@/services/backend/htz/confirmations/components/confirmation-data-card";
import { Textblocks } from "@/services/backend/textblocks/components/textblocks";
import { GSMSubdomain } from "@/shared/types/gsm-subdomain";
import { useParams } from "react-router";

export function DataRoute() {
  const { confirmationId } = useParams();

  if (!confirmationId) {
    return null;
  }

  return (
    <div className="grid gap-2">
      <ConfirmationDataCard confirmationId={confirmationId} />
      <Textblocks
        subdomain={GSMSubdomain.HTZ}
        documentKind={GSMDocumentKind.Confirmation}
        documentId={confirmationId}
        defaultOpen={false}
        title={t("Bemerkungen auf Auftragsbestätigung")}
      />
    </div>
  );
}
